export default __webpack_public_path__ + "static/thumb-landscape-c7e314b3fe47463e7cd277cf99cff1b3.jpg";